import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TeamSection = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  const teamMembers = [
  {
    id: 1,
    name: "Dr. Marcus Weber",
    position: "Founding Partner & CEO",
    image: "https://images.unsplash.com/photo-1714974528889-d51109fb6ae9",
    imageAlt: "Professional headshot of middle-aged man with gray hair in dark suit smiling confidently",
    expertise: ["Strategic Planning", "M&A", "Digital Transformation", "European Markets"],
    bio: "Former McKinsey partner with 20+ years in strategic consulting and venture capital. Led digital transformation initiatives for Fortune 500 companies across Europe.",
    achievements: [
    "Led €500M+ in successful exits",
    "Former McKinsey Senior Partner",
    "Harvard Business School MBA",
    "Published author on digital strategy"],

    linkedin: "https://linkedin.com/in/marcus-weber",
    email: "marcus.weber@rexfel.com"
  },
  {
    id: 2,
    name: "Sarah Chen",
    position: "Managing Partner",
    image: "https://images.unsplash.com/photo-1734456611474-13245d164868",
    imageAlt: "Professional Asian woman with long dark hair in navy blazer smiling warmly at camera",
    expertise: ["Fintech", "SaaS", "Growth Strategy", "International Expansion"],
    bio: "Former Goldman Sachs VP turned venture capitalist. Specializes in fintech and SaaS investments with deep expertise in scaling international operations.",
    achievements: [
    "15+ successful portfolio exits",
    "Former Goldman Sachs VP",
    "Stanford MBA",
    "Fintech innovation award winner"],

    linkedin: "https://linkedin.com/in/sarah-chen",
    email: "sarah.chen@rexfel.com"
  },
  {
    id: 3,
    name: "Thomas Müller",
    position: "Investment Director",
    image: "https://images.unsplash.com/photo-1726440464439-81579d883f5e",
    imageAlt: "Young professional man with short brown hair in light blue shirt smiling confidently",
    expertise: ["E-commerce", "Marketplace", "Operations", "Due Diligence"],
    bio: "E-commerce veteran with operational experience at Zalando and Amazon. Brings hands-on scaling expertise to portfolio companies.",
    achievements: [
    "Scaled 3 companies to €100M+ revenue",
    "Former Zalando Operations Director",
    "INSEAD MBA",
    "E-commerce thought leader"],

    linkedin: "https://linkedin.com/in/thomas-mueller",
    email: "thomas.mueller@rexfel.com"
  },
  {
    id: 4,
    name: "Dr. Elena Rodriguez",
    position: "Technology Partner",
    image: "https://images.unsplash.com/photo-1706565029882-6f25f1d9af65",
    imageAlt: "Professional Hispanic woman with shoulder-length dark hair in white blazer smiling professionally",
    expertise: ["AI/ML", "Blockchain", "Deep Tech", "Product Strategy"],
    bio: "Former CTO at leading European tech companies. PhD in Computer Science with expertise in AI, blockchain, and emerging technologies.",
    achievements: [
    "20+ patents in AI/ML",
    "Former CTO at 2 unicorns",
    "MIT PhD Computer Science",
    "Tech innovation awards"],

    linkedin: "https://linkedin.com/in/elena-rodriguez",
    email: "elena.rodriguez@rexfel.com"
  },
  {
    id: 5,
    name: "James Mitchell",
    position: "Principal",
    image: "https://images.unsplash.com/photo-1654727157781-e4d438e3a02a",
    imageAlt: "Young professional man with dark hair in charcoal suit smiling warmly",
    expertise: ["Early Stage", "Market Analysis", "Financial Modeling", "Startup Mentoring"],
    bio: "Rising star in venture capital with background in investment banking and startup operations. Focuses on early-stage investments and founder support.",
    achievements: [
    "Identified 5 unicorn investments",
    "Former JP Morgan Analyst",
    "Oxford Economics degree",
    "Young VC leader award"],

    linkedin: "https://linkedin.com/in/james-mitchell",
    email: "james.mitchell@rexfel.com"
  },
  {
    id: 6,
    name: "Anna Kowalski",
    position: "Operations Director",
    image: "https://images.unsplash.com/photo-1662104935703-b4e193c3a852",
    imageAlt: "Professional woman with blonde hair in dark business suit smiling confidently",
    expertise: ["Portfolio Support", "Operations", "HR Strategy", "Process Optimization"],
    bio: "Operations expert with experience scaling teams and processes at high-growth startups. Leads portfolio company support initiatives.",
    achievements: [
    "Scaled 10+ portfolio companies",
    "Former Rocket Internet VP",
    "Wharton MBA",
    "Operations excellence award"],

    linkedin: "https://linkedin.com/in/anna-kowalski",
    email: "anna.kowalski@rexfel.com"
  }];


  return (
    <section className="py-20 bg-muted/30">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div className="w-10 h-10 rounded-brand bg-gradient-to-br from-primary to-accent flex items-center justify-center">
              <Icon name="Users" size={20} className="text-white" />
            </div>
            <span className="text-primary font-semibold text-lg">Our Team</span>
          </div>
          
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Expertise That
            <span className="text-gradient-brand block">Drives Success</span>
          </h2>
          
          <p className="text-xl text-muted-foreground leading-relaxed">
            Meet the strategic minds behind REXFEL's success. Our diverse team combines decades of 
            investment experience with deep operational expertise across technology, finance, and scaling.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {teamMembers?.map((member, index) =>
          <div
            key={member?.id}
            className={`group bg-card rounded-brand-lg overflow-hidden shadow-brand hover-lift transition-brand border border-border cursor-pointer scroll-reveal stagger-${index % 3 + 1}`}
            onClick={() => setSelectedMember(member)}>

              <div className="relative overflow-hidden">
                <Image
                src={member?.image}
                alt={member?.imageAlt}
                className="w-full h-64 object-cover group-hover:scale-105 transition-brand" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-brand"></div>
                <div className="absolute bottom-4 left-4 right-4 opacity-0 group-hover:opacity-100 transition-brand">
                  <div className="flex space-x-2">
                    <a
                    href={member?.linkedin}
                    className="w-8 h-8 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-brand"
                    onClick={(e) => e?.stopPropagation()}>

                      <Icon name="Linkedin" size={16} className="text-white" />
                    </a>
                    <a
                    href={`mailto:${member?.email}`}
                    className="w-8 h-8 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-brand"
                    onClick={(e) => e?.stopPropagation()}>

                      <Icon name="Mail" size={16} className="text-white" />
                    </a>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-foreground mb-1">{member?.name}</h3>
                <p className="text-primary font-medium mb-4">{member?.position}</p>
                
                <div className="flex flex-wrap gap-2 mb-4">
                  {member?.expertise?.slice(0, 3)?.map((skill, skillIndex) =>
                <span
                  key={skillIndex}
                  className="text-xs bg-primary/10 text-primary px-2 py-1 rounded-brand-xs font-medium">

                      {skill}
                    </span>
                )}
                  {member?.expertise?.length > 3 &&
                <span className="text-xs bg-muted text-muted-foreground px-2 py-1 rounded-brand-xs font-medium">
                      +{member?.expertise?.length - 3} more
                    </span>
                }
                </div>
                
                <p className="text-sm text-muted-foreground leading-relaxed line-clamp-3">
                  {member?.bio}
                </p>
                
                <div className="mt-4 flex items-center text-primary text-sm font-medium group-hover:text-accent transition-brand">
                  <span>View Profile</span>
                  <Icon name="ArrowRight" size={14} className="ml-2 group-hover:translate-x-1 transition-brand" />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Team Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 bg-card rounded-brand-lg p-8 shadow-brand border border-border">
          <div className="text-center">
            <div className="text-3xl font-bold text-primary counter-animate">150+</div>
            <div className="text-sm text-muted-foreground font-medium">Combined Years Experience</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-primary counter-animate">25+</div>
            <div className="text-sm text-muted-foreground font-medium">Successful Exits</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-primary counter-animate">8</div>
            <div className="text-sm text-muted-foreground font-medium">Advanced Degrees</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-primary counter-animate">12</div>
            <div className="text-sm text-muted-foreground font-medium">Industry Awards</div>
          </div>
        </div>
      </div>
      {/* Member Detail Modal */}
      {selectedMember &&
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-card rounded-brand-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-brand-modal">
            <div className="relative">
              <button
              onClick={() => setSelectedMember(null)}
              className="absolute top-4 right-4 w-8 h-8 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/20 transition-brand z-10">

                <Icon name="X" size={16} />
              </button>
              
              <div className="p-8">
                <div className="flex items-start space-x-6 mb-6">
                  <Image
                  src={selectedMember?.image}
                  alt={selectedMember?.imageAlt}
                  className="w-24 h-24 rounded-brand object-cover" />

                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-foreground mb-1">{selectedMember?.name}</h3>
                    <p className="text-primary font-medium mb-4">{selectedMember?.position}</p>
                    <div className="flex space-x-3">
                      <a
                      href={selectedMember?.linkedin}
                      className="flex items-center space-x-2 text-sm text-muted-foreground hover:text-primary transition-brand">

                        <Icon name="Linkedin" size={16} />
                        <span>LinkedIn</span>
                      </a>
                      <a
                      href={`mailto:${selectedMember?.email}`}
                      className="flex items-center space-x-2 text-sm text-muted-foreground hover:text-primary transition-brand">

                        <Icon name="Mail" size={16} />
                        <span>Email</span>
                      </a>
                    </div>
                  </div>
                </div>
                
                <div className="space-y-6">
                  <div>
                    <h4 className="text-lg font-semibold text-foreground mb-3">Biography</h4>
                    <p className="text-muted-foreground leading-relaxed">{selectedMember?.bio}</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-semibold text-foreground mb-3">Expertise Areas</h4>
                    <div className="flex flex-wrap gap-2">
                      {selectedMember?.expertise?.map((skill, index) =>
                    <span
                      key={index}
                      className="bg-primary/10 text-primary px-3 py-1 rounded-brand-xs font-medium text-sm">

                          {skill}
                        </span>
                    )}
                    </div>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-semibold text-foreground mb-3">Key Achievements</h4>
                    <ul className="space-y-2">
                      {selectedMember?.achievements?.map((achievement, index) =>
                    <li key={index} className="flex items-start space-x-3">
                          <Icon name="CheckCircle" size={16} className="text-success mt-0.5 flex-shrink-0" />
                          <span className="text-muted-foreground text-sm">{achievement}</span>
                        </li>
                    )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </section>);

};

export default TeamSection;